export default __webpack_public_path__ + "static/media/lottery-wheel-frame-icdesign.2b71a53c.png";